import React, { useRef, useState } from "react";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import { buttonThemes } from "@streeteasy/design-system/deprecated/actions/button";
import { PrimaryMedium } from "@streeteasy/design-system/typography";
import { bool } from "prop-types";
import SwiperCore, { A11y, Keyboard, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

import { smallScreen } from "src/shared/constants/screenSizes";

import useSwiperRef from "../../hooks/useSwiperRef";
import * as propTypes from "../../propTypes";
import RecentlyViewedListing from "../RecentlyViewedListing";
import * as S from "./styled";

SwiperCore.use([Keyboard, Navigation]);

const RecentlyViewedListings = ({
  isRecommendedListings,
  recentlyViewedListings
}) => {
  const [isAllVisible, setIsAllVisible] = useState(false);
  const swiperRef = useRef();
  const [prevEl, prevElRef] = useSwiperRef();
  const [nextEl, nextElRef] = useSwiperRef();

  return (
    <S.RecentlyViewedContainer>
      <PrimaryMedium as="h2">Take another look</PrimaryMedium>
      <S.SliderWrapper>
        <S.PreviousButton ref={prevElRef} disabled type="previous">
          Previous listing
        </S.PreviousButton>
        <S.NextButton ref={nextElRef} disabled type="next">
          Next listing
        </S.NextButton>
        <Swiper
          a11y={{
            prevSlideMessage: "Previous listing",
            nextSlideMessage: "Next listing"
          }}
          breakpoints={{
            // when window width is >= smallScreen - 1(767px)
            [smallScreen - 1]: {
              slidesPerView: 2,
              enabled: true
            },
            // when window width is >= largeScreen(979px)
            1090: {
              slidesPerView: 3
            },
            // when window width is >= 1290
            1416: {
              slidesPerView: 4
            }
          }}
          keyboard={{
            enabled: !isRecommendedListings,
            onlyInViewport: true
          }}
          modules={[Navigation, A11y]}
          navigation={{
            prevEl,
            nextEl
          }}
          onSwiper={swiper => {
            swiperRef.current = swiper;
          }}
          spaceBetween={16}
        >
          {recentlyViewedListings.map((listing, index) => (
            <SwiperSlide
              key={listing.id}
              onFocus={event => {
                /*
                 * This is necessary to fix an accessibility bug in the slider.
                 * More info at https://github.com/nolimits4web/swiper/issues/4006
                 */

                if (!swiperRef.current || event.target.nodeName === "BUTTON") {
                  return;
                }

                swiperRef.current.el.scrollLeft = 0;
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(index);
              }}
            >
              <S.ListingCardWrapper>
                <RecentlyViewedListing listing={listing} />
              </S.ListingCardWrapper>
            </SwiperSlide>
          ))}
        </Swiper>
      </S.SliderWrapper>
      <S.MobileListings>
        {recentlyViewedListings.map((listing, index) => {
          if (index > 2 && !isAllVisible) return null;

          return (
            <S.ListingCardWrapper key={listing.id}>
              <RecentlyViewedListing listing={listing} />
            </S.ListingCardWrapper>
          );
        })}
        {recentlyViewedListings.length > 3 && (
          <S.SeeMoreButton
            isVisible={!isAllVisible}
            onClick={() => setIsAllVisible(true)}
            size={componentSizes.LG}
            theme={buttonThemes.SECONDARY}
          >
            See all
          </S.SeeMoreButton>
        )}
      </S.MobileListings>
    </S.RecentlyViewedContainer>
  );
};

RecentlyViewedListings.defaultProps = {
  isRecommendedListings: false
};

RecentlyViewedListings.propTypes = {
  recentlyViewedListings: propTypes.recentlyViewedListingsProps.isRequired,
  isRecommendedListings: bool
};

export default RecentlyViewedListings;
